import { makeStyles } from '@material-ui/core/styles';


export const useProductStyles = makeStyles((theme) => ({

    button: {
      margin: theme.spacing(1),
      fontWeight : "Bold",       
    },
    chips: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    chip: {
      margin: 2,
    },

    linkStyle:{
        textDecoration :"None",
    },

    formEntry :{
        marginTop : theme.spacing(5),
    },

    textEntry : {
        width : "600px"
    },
    input: {
        display: 'none',
      },

    spotImg:{
        maxWidth:"100%",
        maxHeight:"100%"
      },

    spotCont:{
        opacity:0.5,
        backgroundColor:"black",
        width: "calc(100vw)", 
         fallbacks:["-moz-calc(100vw)", 
         "-webkit-calc(100vw)",
         "-o-calc(100vw)"
         ]
      }
  }));